var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 11.6667V9.16671H14.9998V7.50004L18.3332 10.4167L14.9998 13.3334V11.6667H12.4998ZM11.6665 6.41671V7.50004H1.6665V6.41671L6.6665 3.33337L11.6665 6.41671ZM5.83317 8.33337H7.49984V12.5H5.83317V8.33337ZM2.49984 8.33337H4.1665V12.5H2.49984V8.33337ZM10.8332 8.33337V10.4167L9.1665 11.9167V8.33337H10.8332ZM7.58317 13.3334L7.08317 13.75L8.49984 15H1.6665V13.3334H7.58317ZM14.1665 12.5V15H11.6665V16.6667L8.33317 13.75L11.6665 10.8334V12.5H14.1665Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemIcon);
export default __webpack_public_path__ + "static/media/redeem-icon.ed796b844902a745de1146dd9e5f65a6.svg";
export { ForwardRef as ReactComponent };